const EllipsisDecorationWhiteTiny = () => {
    return (
        <div>
            <div className='ellipsis-decoration-white-large-c'></div>
            <div className='ellipsis-decoration-white-medium-c'></div>
            <div className='ellipsis-decoration-white-small-c'></div>
        </div>
    )
}

export default EllipsisDecorationWhiteTiny